"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ErrorPageSharedContent_1 = __importDefault(require("./ErrorPageSharedContent"));
function ErrorPage() {
    return (react_1.default.createElement(ErrorPageSharedContent_1.default, { errorHeadingText: 'apptNotFoundHeader', bannerText: 'apptNotFoundBanner' }));
}
exports.default = ErrorPage;
//# sourceMappingURL=ErrorPage.js.map